// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue16(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
            style={{
                enableBackground: 'new 0 0 250 250',
            }}
            xmlSpace="preserve"
            {...props}
        >
            <style type="text/css">
                {
                    "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#A98C48;}\n\t.st4{fill:#68836A;}\n\t.st5{font-family:'ArialMT';}\n\t.st6{font-size:11px;}\n\t.st7{fill:#A88B49;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:2;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;}\n\t.st10{fill:none;stroke:#FFFFFF;stroke-width:1.5;}\n"
                }
            </style>
            <g id="ATL_-_16">
                <g id="Compass_copy_11">
                    <g id="compass">
                        <polygon
                            className="st0"
                            points="231.2,207.4 225.5,200.2 223.1,192.6 228.4,198.6  "
                        />
                        <path
                            className="st1"
                            d="M234.5,213.1c-7.5,4.1-16.9,1.4-21.1-6c-4.1-7.5-1.4-16.9,6-21.1c7.5-4.1,16.9-1.4,21.1,6 C244.7,199.5,242,208.9,234.5,213.1z M220.1,187.1c-6.8,3.8-9.3,12.4-5.5,19.3c3.8,6.8,12.4,9.3,19.3,5.5 c6.8-3.8,9.3-12.4,5.5-19.3C235.6,185.8,227,183.3,220.1,187.1z"
                        />
                        <ellipse
                            transform="matrix(0.2752 -0.9614 0.9614 0.2752 -27.2691 362.8697)"
                            className="st0"
                            cx={227}
                            cy={199.5}
                            rx={3}
                            ry={3}
                        />
                        <g>
                            <path
                                className="st0"
                                d="M221.5,192l-1.5-2.7l0.4-0.2l2.3,1.2l0,0l-1-1.9l0.5-0.3l1.5,2.7l-0.4,0.2l-2.3-1.2l0,0l1,1.9L221.5,192z"
                            />
                        </g>
                        <ellipse
                            transform="matrix(0.2751 -0.9614 0.9614 0.2751 -27.2615 362.8816)"
                            className="st2"
                            cx={227}
                            cy={199.5}
                            rx={1.6}
                            ry={1.6}
                        />
                    </g>
                </g>
                <path
                    className="st3"
                    d="M231.6,116.3l-6.6-11.2l-23.7-48.5l-21.1-14.8c0,0-39.8-11.1-50-10.8c-59,1.9-96.8,47.1-96.8,47.1l-11.5,22.1 l-3.3,15.2l18.8,15.5L64,177.3c0,0,19.5,22.7,24.1,28c4.6,5.3,16.1,17.9,19.7,21.5c3.6,3.6,8.9,7.1,15.5,7.4 c6.6,0.3,16-7.5,25.9-19.1c9.9-11.5,32-33.3,32-33.3l20.1-33.6L231.6,116.3z"
                />
                <path
                    className="st4"
                    d="M225.3,118.4l-5.8-13.5l-23.8-47l-18.3-12.2c0,0-34.3-10.8-44.3-10.5c-57.5,1.9-91.1,43.4-91.1,43.4 l-13.5,24.7L28,118.2l12.2,10.3l26,45.3c0,0,19,22.2,23.5,27.3c4.5,5.1,15.6,17.5,19.2,21c3.5,3.5,8.6,6.9,15.1,7.2 c6.4,0.3,15.6-7.4,25.2-18.6c9.6-11.2,31.2-32.5,31.2-32.5l19.6-32.8L225.3,118.4z"
                />
                <g id="infield_sand_copy_4">
                    <path
                        className="st3"
                        d="M164.3,168.5c0,0-12-31-38.8-30.8c-27.3,0.2-39.4,30.1-39.4,30.1l32.5,31.2c-1.2,1.1-1.6,3.3-1.6,4.5 c0,4.4,3.7,8,8.2,8c4.5,0,8.2-3.6,8.2-8c0-1.4-0.4-2.8-1.1-4L164.3,168.5z M125.1,195.5c-1.2,0-2.3,0.2-3.3,0.7l-18.3-17.9 c1.1-1.4,1.8-3.1,1.8-5c0-0.9-0.2-1.8-0.5-2.7l15.6-15.2c1.3,0.9,3,1.5,4.8,1.5c1.7,0,3.3-0.5,4.6-1.4l15.5,15.2 c-0.3,0.8-0.5,1.7-0.5,2.6c0,1.9,0.7,3.6,1.8,5l-18.4,17.9C127.4,195.7,126.3,195.5,125.1,195.5z"
                    />
                </g>
                <text
                    transform="matrix(1 0 0 1 2.5835 113.2129)"
                    className="st4 st5 st6"
                >
                    335
                </text>
                <text
                    transform="matrix(1 0 0 1 226.7085 100.7139)"
                    className="st4 st5 st6"
                >
                    330
                </text>
                <text
                    transform="matrix(1 0 0 1 194.5464 43.9053)"
                    className="st4 st5 st6"
                >
                    390
                </text>
                <text
                    transform="matrix(1 0 0 1 121.4312 25.1065)"
                    className="st4 st5 st6"
                >
                    401
                </text>
                <text
                    transform="matrix(1 0 0 1 27.3965 59.6983)"
                    className="st4 st5 st6"
                >
                    380
                </text>
            </g>
            <g id="Pitchers_mound">
                <ellipse
                    transform="matrix(0.7071 -0.7071 0.7071 0.7071 -88.7986 140.5403)"
                    className="st7"
                    cx={125.2}
                    cy={177.5}
                    rx={3.8}
                    ry={3.8}
                />
            </g>
            <g id="Bases_and_chalk_lines-ALL">
                <g>
                    <path className="st8" d="M15.6,93.6" />
                    <path className="st8" d="M125.2,204.3" />
                    <path className="st8" d="M232,94.3" />
                </g>
                <rect
                    x={123.2}
                    y={176.7}
                    className="st9"
                    width={4}
                    height={1.6}
                />
                <rect
                    x={98.4}
                    y={174.6}
                    transform="matrix(0.7073 -0.7069 0.7069 0.7073 -95.2212 122.1912)"
                    className="st9"
                    width={3}
                    height={3}
                />
                <rect
                    x={148.9}
                    y={174.6}
                    transform="matrix(0.7073 -0.7069 0.7069 0.7073 -80.4458 157.8735)"
                    className="st9"
                    width={3}
                    height={3}
                />
                <rect
                    x={123.7}
                    y={149.3}
                    transform="matrix(0.707 -0.7073 0.7073 0.707 -70.0001 132.7314)"
                    className="st9"
                    width={3}
                    height={3}
                />
                <polygon
                    className="st9"
                    points="126.7,201.9 125.2,203.4 123.7,201.9 123.7,200.4 126.7,200.4  "
                />
                <polyline
                    className="st10"
                    points="234.6,94.3 125.2,203.5 17.9,96.2  "
                />
            </g>
        </svg>
    )
}
export default Venue16
